<template>
  <div>
    <template v-if="$store.getters.getUserHasFeature('customers')">
    <customers-list
      v-if="loaded"
      :withFilters="true"
      :hasPagination="true"
      :listSource="'adviser/customers/items'"
      :whereFilter="whereFilter"/>
    </template>
    <div
      v-else
      class="wrapper pt-3 pb-1">
      <f-alert
        visible
        class="my-2"
        theme="inactive">
        <span>
        {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
        </span>
      </f-alert>
    </div>
    <div
      v-if="!loaded"
      class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CustomersList from '@/views/lists/CustomersList.vue';

export default {
  name: 'customers',
  components: {
    'customers-list': CustomersList
  },
  data() {
    return {
      whereFilter: null,
      loaded: false
    };
  },
  mounted () {
    if (this.$route.query) {
      this.whereFilter = this.$route.query;
    }
    this.loaded = true;
  }
};
</script>
